BX.Vue.component('aos__doc-gen',
    {
        computed: {
        },
        data: function () {
            return {
                email: null
            };
        },
        methods: {
            msg: function (code) {
                return BX.aBase.msg(code);
            },
            init: function () {
                let vm = this;
                vm.actions();
                vm.inputMask();
            },
            validateEmail: function (value) {
                let vm = this;
                if (!value) {
                    return false;
                }
                let domains = [
                    'protonmail.com',
                    'ukr.net',
                    'icloud.com',
                    '.ua',
                    'bigmir.net'
                ];
                for (let i in domains) {
                    let domain = domains[i];
                    if (domain[0] !== '.') {
                        domains.push('.' + domains[i]);
                    }
                }
                let isEmailDomainError = false;
                domains.forEach(function(domain) {
                    if (!isEmailDomainError) {
                        let emailPosition = value.indexOf('@');
                        if (emailPosition !== -1) {
                            let emailDomain = value.slice(emailPosition + 1);
                            if (domain[0] === '.') {
                                if (emailDomain.indexOf(domain, (emailDomain.length - 1) - (domain.length - 1)) !== -1) {
                                    isEmailDomainError = true;
                                }
                            } else {
                                if (domain === emailDomain) {
                                    isEmailDomainError = true;
                                }
                            }
                        }
                    }
                });

                let pattern = /(?:[a-z0-9_+-]+(?:\.[a-z0-9_+-]+)*|\“(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\”)@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gm;
                let testPattern = value.match(pattern);
                let currentEmail = vm.$parent.aos.querySelector('.ocf__info-email').innerHTML;
                let emailSave = vm.$parent.aos.querySelector('#email_save');
                let res = !isEmailDomainError && testPattern && testPattern[0] === value && value !== currentEmail;
                if (res) {
                    emailSave.removeAttribute('disabled');
                } else {
                    emailSave.setAttribute('disabled', 'disabled');
                }

                return res;
            },
            inputMask: function() {
                let vm = this;
                let temp = setInterval(function () {
                    let email = $('[name=email]');
                    if (email.length > 0) {
                        clearInterval(temp);
                        email.inputmask({
                            alias: 'email',
                            showMaskOnHover: false,
                            showMaskOnFocus: false,
                            onincomplete: function() {
                                vm.$parent.checkEmptyField(this);
                                if (!this.value || vm.validateEmail(this.value)) {
                                    vm.$parent.removeError(this);
                                } else {
                                    vm.$parent.addError(this);
                                }
                            },
                            oncleared: function() {
                                vm.$parent.removeError(this);
                            }
                        }).on('paste change', function() {
                            vm.$parent.checkEmptyField(this);
                            if (!this.value || vm.validateEmail(this.value)) {
                                vm.$parent.removeError(this);
                            } else {
                                vm.$parent.addError(this);
                            }
                        }).on('keyup', function() {
                            vm.validateEmail(this.value);
                        });
                    }

                }, 100);
            },
            actions: function () {
            },
            emailChangeOpen: function () {
                let vm = this;
                let emailChangeOpen = vm.$parent.aos.querySelector('#email_change_open');
                let emailChange = vm.$parent.aos.querySelector('.ocf__info-emailc');
                emailChangeOpen.style.display = 'none';
                emailChange.style.display = 'block';
            },
            emailChange: function () {
                let vm = this;
                let email = vm.$parent.aos.querySelector('[name=email]').value;
                let emailSave = vm.$parent.aos.querySelector('#email_save');
                emailSave.classList.add('clicked');
                emailSave.style.pointerEvent = 'none';

                BX.ajax.runComponentAction(
                    'aton:aos',
                    'changeEmail',
                    {
                        url: location.pathname,
                        method: 'post',
                        mode: 'class',
                        data: {
                            email: email,
                        },
                    }
                ).then(function (request) {
                    if (request.data.status === 'success') {
                        let ocfInfo = vm.$parent.aos.querySelector('.ocf__info-wrap');
                        ocfInfo.style.display = 'none';
                        let ocfSuccess = vm.$parent.aos.querySelector('.ocf__block-success-send')
                        ocfSuccess.style.display = 'block';
                    } else {
                        vm.$parent.messageError(request.data.message);
                        vm.$parent.scrollToElement('#aos', 0);
                    }
                    emailSave.classList.remove('clicked');
                    emailSave.style.pointerEvent = 'all';
                    if (request.data.state === 'processBan') {
                        vm.$parent.step = 'BAN';
                    }
                }).catch(function () {
                    emailSave.classList.remove('clicked');
                    emailSave.style.pointerEvent = 'all';
                    vm.$parent.messageError(vm.msg('A_AOS_DOC_GEN_ERROR_DEFAULT'));
                    vm.$parent.scrollToElement('#aos', 0);
                });
            }
        },
        mounted: function () {
            let vm = this;
            vm.$parent.title = vm.msg('A_AOS_DOC_GEN_TITLE');
            vm.$parent.titleClass = 'ocf__info__title';
            if (vm.$parent.clientData.email) {
                vm.email = vm.$parent.clientData.email;
            }
            vm.init();
            vm.$parent.removeMessageError();
            vm.$parent.scrollToElement('._aos', 0);
        },
        template: `
          <div class="aos__doc-gen">
          <div class="ocf__section ocf__section-visible">
            <div class="ocf__block ocf__info-wrap">
              <div class="ocf__info">
                <div class="ocf__info-block">
                  <div class="ocf__info-desc" v-html="msg('A_AOS_DOC_GEN_DESC')"></div>
                </div>
              </div>
              <div class="ocf__info" v-if="email">
                <div class="ocf__info-block">
                  <div class="ocf__info-desc">
                    <div id="popup-desc">
                      {{ msg('A_AOS_DOC_GEN_U_EMAIL') }}
                      <div class="ocf__info-email" v-html="email"></div>
                    </div>
                    <div class="ocf__info-buttons">
                      <button id="email_change_open" class="button ocf__info-button blue-bord" v-html="msg('A_AOS_DOC_GEN_CHANGE_EMAIL')" v-on:click="emailChangeOpen"></button>
                    </div>
                    <div class="ocf__section ocf__info-emailc">
                      <label class="form__field form__field-required field_email">
                        <input class="form__text-input" type="text" name="email" value="" inputmode="email">
                        <span class="place_holder" data-field="email">Email<span>*</span></span>
                      </label>
                      <div class="ocf__info-buttons">
                        <button id="email_save" class="button ocf__info-button blue-bord" v-html="msg('A_AOS_DOC_GEN_SAVE')" v-on:click="emailChange" disabled></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ocf__block ocf__block-success-send"><form class="form"><div class="form__success-send__text" v-html="msg('A_AOS_DOC_GEN_SUCCESS_MESSAGE')"></div></form></div>
          </div>
          </div>
        `,
    }
);